function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as o } from "react/jsx-runtime";
import { useIsInverseVariant as s } from "../../theme-variant-context.js";
import { vars as r } from "../../skins/skin-contract.css-mistica.js";
const i = (_param)=>{
    var { color: t , size: c = 24  } = _param, a = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const n = s(), e = t !== null && t !== void 0 ? t : n ? r.colors.inverse : r.colors.neutralHigh;
    return /* @__PURE__ */ o("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, a), {
        children: /* @__PURE__ */ o("path", {
            fill: e,
            d: "M17.39 9.732c.23-.078.49-.118.774-.118 1.258 0 2.036.79 2.039 2.065v7c0 .969-.272 1.745-.81 2.3-.54.557-1.378.865-2.36.865H9.244c-.782 0-1.126-.745-1.272-1.062-.137-.298-.613-1.265-1.17-2.396l-.04-.08-.208-.424a404.696 404.696 0 01-2.537-5.223c-.4-.854-.24-1.742.41-2.263a1.789 1.789 0 011.13-.398c.44.003.866.154 1.208.432.364.29.67.694 1.008 1.271l.003-7.428c.087-1.348.863-2.118 2.13-2.118 1.316 0 2.133.826 2.133 2.16v2.904c.208-.058.438-.09.684-.09 1.003 0 1.703.505 1.944 1.354.232-.076.493-.118.776-.118 1.005 0 1.709.51 1.947 1.367zm1.418 10.67c.387-.398.58-.98.58-1.729l-.003-6.991c0-.824-.412-1.241-1.224-1.241-.19 0-.367.025-.518.075a.806.806 0 01-.639-.056.821.821 0 01-.4-.504c-.143-.51-.535-.767-1.166-.767-.193 0-.37.025-.52.075a.819.819 0 01-1.04-.555c-.143-.504-.535-.759-1.162-.759-.171 0-.328.02-.465.06a.823.823 0 01-.219.03.818.818 0 01-.812-.82V4.316c0-.876-.457-1.339-1.32-1.339-.529 0-1.238.138-1.316 1.348V11.7c0 .37-.247.695-.6.793a.811.811 0 01-.915-.373c-.309-.526-.552-.84-.813-1.047a1.125 1.125 0 00-.703-.255.987.987 0 00-.625.218c-.347.278-.414.765-.179 1.266.678 1.449 1.82 3.77 2.74 5.636.552 1.118 1.07 2.177 1.218 2.496.193.42.345.585.535.585h7.787c.762 0 1.393-.22 1.779-.619z"
        })
    }));
}, v = i;
export { v as default };
